export const imageFit = {
  objectFit: "cover",
  width: "100%",
  height: "100%",
  verticalAlign: "middle",
} as const;
